import { HtmlId } from '../enums/elementId';
import { debugInfo } from '../util/debug';

/**
 * Create button link component with onClick action.
 * @param elementOrId ID of the button element or the element itself.
 * @param onClick OnClick event.
 */
export const mountButtonLink = (
    elementOrId: HtmlId | HTMLAnchorElement,
    onClick: Function
): HTMLElement | null => {
    const containerEl = elementOrId instanceof HTMLAnchorElement ?
        elementOrId
        :
        document.getElementById(elementOrId);

    if (!containerEl) {
        debugInfo('Couldn\'t mount Button component with id: ', elementOrId);
        return null;
    }

    containerEl.onclick = (e: Event) => {
        e.preventDefault();
        onClick();
    };

    return containerEl;
};
